<template>
  <div class="LKMunMehFormFooter">
    <v-layout class="text-center">
      <LKProgressCircular
        v-if="loading"
        :size="50"
        style="flex: auto;"
      />
      <v-layout v-else class="LKMunMehFormFooter__layout">
        <v-btn
          color="primary"
          rounded
          outlined
          :disabled="isSavingDisabled"
          @click="$emit('prev')"
          v-text="'Сохранить и перейти назад'"
        />
        <v-btn
          color="primary"
          rounded
          outlined
          :disabled="loading"
          class="ml-btn"
          @click="$emit('main')"
          v-text="'Главный раздел'"
        />
        <v-spacer />
        <v-btn
          color="primary"
          rounded
          outlined
          :disabled="isSavingDisabled"
          @click="$emit('save')"
          v-text="'Сохранить'"
        />
        <v-btn
          color="primary"
          rounded
          :disabled="isSavingDisabled"
          class="ml-btn"
          @click="$emit('next')"
          v-text="'Сохранить и перейти далее'"
        />
      </v-layout>
    </v-layout>
  </div>
</template>

<script>
import LKProgressCircular from '@/components/lk/LKProgressCircular.vue'
import { MunMehFormStatuses } from '@/typings/api/MunMeh'

export default {
  name: 'LKMunMehFormFooter',
  components: { LKProgressCircular },
  props: {
    status: {
      type: String,
      required: true,
    },
    loading: Boolean,
  },
  computed: {
    isSavingDisabled() {
      return [MunMehFormStatuses.submitted.toString(), MunMehFormStatuses.done.toString()].includes(this.status)
          || this.loading
    },
  },
}
</script>

<style scoped lang="scss">
.LKMunMehFormFooter {
  @import "~@/assets/scss/components/_LKHeaderButtons.scss";

  margin-top: 16px;

  .ml-btn {
    margin-left: 12px;
  }
}
</style>

